export const kinderConnectCaptureSettingsFormId = 'kinder-connect-capture-settings-form-id';
